
<!-- Modal -->
<div class="modal fade" *ngIf="adminApi.isLoggedIn()" id="{{modalid}}" tabindex="-1" aria-labelledby="suggestskillModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <form class="" [formGroup]="Form" (ngSubmit)="onSubmit(Form)">
        <div class="modal-body pt-4">
          <h5 class="card-title">{{level?  "Edit Level": "New Level"}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          <div class="form-group">
              <label class="form-label">Level Name</label>
              <input type="text" class="form-control" formControlName="name">
              <div class="invalid-feedback d-block"
                  *ngIf="f2['name'].errors?.['required'] && (f2['name'].dirty || f2['name'].touched)">
                  Please fill name.
              </div>
          </div>
          <div class="form-group mb-0">
            <label class="form-label">Rules Applicable</label>
            <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" formControlName="formrules" multiple class="selectpicker skill font-oswald w-100">
              <option *ngFor="let selectrule of allrules" [value]="selectrule?.id">{{selectrule?.name | titlecase}}</option>
            </select>
            <div class="invalid-feedback d-block"
                *ngIf="f2['formrules']?.errors?.['required'] && f2['formrules'].touched && f2['formrules']?.invalid">
                Please select rules.
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary me-3" data-bs-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-dark btn-gold">Submit <i *ngIf="submitting" class="fa fa-spinner fa-spin"></i></button>
        </div>
      </form>
    </div>
  </div>
</div>